__turbopack_context__.v({
  "filter-footer": "mn4I5q_filter-footer",
  "filter-footer__apply-button": "mn4I5q_filter-footer__apply-button",
});
